import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  Inject,
  inject,
  signal,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
} from '@angular/material/dialog';
import { LogoService, ToastAlertService } from '@core/index';
import { Cookies } from 'typescript-cookie';
import { TitleComponent } from '@shared/components/title/title.component';
import { MatCardModule } from '@angular/material/card';
import { ButtonComponent } from '@shared/components';
import { Store } from '@ngrx/store';

import * as LogoActions from '@store/actions/logo.actions';

@Component({
  selector: 'app-change-logo',
  standalone: true,
  imports: [
    CommonModule,
    TitleComponent,
    MatCardModule,
    ReactiveFormsModule,
    ButtonComponent,
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    ButtonComponent,
  ],
  templateUrl: `./change-logo.component.html`,
  styleUrl: './change-logo.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChangeLogoComponent {
  private formBuilder = inject(FormBuilder);
  changeLogoForm!: FormGroup;
  selectedFile: any = null;
  imageError: string | null = null;
  isImageSaved?: boolean;
  imgBase64 = signal<string>('');
  private logoService = inject(LogoService);
  private destroyRef = inject(DestroyRef);
  private dialogRef = inject(MatDialogRef);
  private alertService = inject(ToastAlertService);
  private cdr = inject(ChangeDetectorRef);
  private readonly store = inject(Store);

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
    if (this.data) {
      this.loadLogo();
    }
  }

  onSubmit() {
    const body = { name: this.data.name, value: this.imgBase64() };
    this.logoService.putLogo(body, this.data.idLogo).subscribe({
      next: ({ reply }) => {
        if (reply) {
          this.store.dispatch(LogoActions.getLogo({ idLogo: reply.logo_id }));
          this.dialogRef.close(true);
          this.alertService.sucess('Logo modificado exitosamente');
        }
      },
    });
  }

  private loadLogo() {
    this.logoService
      .getOneLogo(this.data.idLogo)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: ({ reply }) => {
          this.imgBase64.set(reply.value), (this.isImageSaved = true);
          this.cdr.detectChanges();
        },
      });
  }

  onFileSelected(event: Event) {
    const inputElement = event.target as HTMLInputElement;

    if (inputElement.files && inputElement.files[0]) {
      const max_size = 5242880;
      const allowed_types = ['image/png', 'image/jpeg'];
      // const max_height = 5000;
      //const max_width = 4000;

      if (inputElement.files[0].size > max_size) {
        this.imageError =
          'El tamaño máximo es ' + Math.trunc(max_size) / 1000000 + 'Mb';
        return false;
      }

      if (!allowed_types.includes(inputElement.files[0].type)) {
        this.imageError = 'Solo documentos ( JPG | PNG )';
        return false;
      }

      const reader = new FileReader();
      reader.onload = (e: ProgressEvent) => {
        const image = new Image();
        image.src = (e.target as any).result;

        image.onload = rs => {
          const img_height = (rs.currentTarget as HTMLImageElement).height;
          const img_width = (rs.currentTarget as HTMLImageElement).width;

          console.log(img_height, img_width);

          const imgBase64Path = (e.target as any).result;
          this.imgBase64.update(() => imgBase64Path);
          this.isImageSaved = true;
        };
      };

      reader.readAsDataURL(inputElement.files[0]);
    }

    return true;
  }
}
